import { RESPONSEDATA } from "app/shared/services/services-model.type";
import { FormFilterTransHistory } from "../list-transaction-history/filter-transaction-history-table/filter-transaction-table.web";
import {
  SET_TRANS_HISTORY,
  SET_TRANS_HISTORY_RESET,
  FETCH_TRANS_HISTORY_REQUEST,
  FETCH_TRANS_HISTORY_SUCCESS,
  FETCH_TRANS_HISTORY_FAILURE,
  FETCH_TRANS_HISTORY_BACKUP_REQUEST,
  FETCH_TRANS_HISTORY_BACKUP_SUCCESS,
  FETCH_TRANS_HISTORY_BACKUP_FAILURE,
} from "./actions.type";
import {
  FetchTransHistoryRequest,
  FetchTransHistorySuccess,
  FetchTransHistoryFailure,
  FetchTransHistoryBackupRequest,
  FetchTransHistoryBackupSuccess,
  FetchTransHistoryBackupFailure,
  SetTransHistory,
  SetTransHistoryReset,
  TransHistoryState,
} from "./types";

export const setTransHistory = (payload?: TransHistoryState): SetTransHistory => ({
  type: SET_TRANS_HISTORY,
  payload,
});

export const fetchTransHistoryRequest = (payload?: FormFilterTransHistory): FetchTransHistoryRequest => ({
  type: FETCH_TRANS_HISTORY_REQUEST,
  payload,
});

export const fetchTransHistorySuccess = (payload?: RESPONSEDATA): FetchTransHistorySuccess => ({
  type: FETCH_TRANS_HISTORY_SUCCESS,
  payload,
});

export const fetchTransHistoryFailure = (): FetchTransHistoryFailure => ({
  type: FETCH_TRANS_HISTORY_FAILURE,
});

export const fetchTransHistoryBackupRequest = (payload?: FormFilterTransHistory): FetchTransHistoryBackupRequest => ({
  type: FETCH_TRANS_HISTORY_BACKUP_REQUEST,
  payload,
});

export const fetchTransHistoryBackupSuccess = (payload?: RESPONSEDATA): FetchTransHistoryBackupSuccess => ({
  type: FETCH_TRANS_HISTORY_BACKUP_SUCCESS,
  payload,
});

export const fetchTransHistoryBackupFailure = (): FetchTransHistoryBackupFailure => ({
  type: FETCH_TRANS_HISTORY_BACKUP_FAILURE,
});

export const setTransHistoryReset = (): SetTransHistoryReset => ({
  type: SET_TRANS_HISTORY_RESET,
});
